export default __webpack_public_path__ + "static/MMG-01-9a616309b0c22a8f7ddfa0df573911d7.png";